import { useLang } from "@/i18n";
import { PageHero } from "@/components/common";
import { EcosystemSection } from "@/components/home/EcosystemSection";
import { Benefits } from "@/components/home/Benefits";

export default function Ecosystem() {
  const { t } = useLang();
  return (
    <>
      <PageHero eyebrow={t("eco.eyebrow")} title={t("eco.title")} />
      <EcosystemSection compact />
      <Benefits />
    </>
  );
}
